export default __webpack_public_path__ + "static/media/callIcon.7cc2fd96.svg";